/**
 * AlmadarPostLearningFromInterruptionsENPostPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait AlmadarPostLearningFromInterruptionsENPostPage
 */

import { useAlmadarPostLearningFromInterruptionsENPostPageLogic } from '@/hooks/traits/useAlmadarPostLearningFromInterruptionsENPostPageLogic';
import type { AlmadarPostLearningFromInterruptionsENPostPageConfig } from '@/hooks/traits/useAlmadarPostLearningFromInterruptionsENPostPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { AlmadarPostLearningFromInterruptionsENPostView as AlmadarPostLearningFromInterruptionsENPostViewEntity } from '@app/shared';
import { Stack } from '@almadar/ui/components';
import { Container } from '@almadar/ui/components';
import { AlmadarPostLearningFromInterruptionsENPostView } from '@/components/traits/AlmadarPostLearningFromInterruptionsENPostView';
import { AlmadarPostLearningFromInterruptionsENPostFooterView } from '@/components/traits/AlmadarPostLearningFromInterruptionsENPostFooterView';
import { Box } from '@almadar/ui/components';
import { AlmadarPostLearningFromInterruptionsENPostHeaderView } from '@/components/traits/AlmadarPostLearningFromInterruptionsENPostHeaderView';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface AlmadarPostLearningFromInterruptionsENPostPageViewProps {
  config?: Partial<AlmadarPostLearningFromInterruptionsENPostPageConfig>;
}

export function AlmadarPostLearningFromInterruptionsENPostPageView({ config: propsConfig }: AlmadarPostLearningFromInterruptionsENPostPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useAlmadarPostLearningFromInterruptionsENPostPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['AlmadarPostLearningFromInterruptionsENPostView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="AlmadarPostLearningFromInterruptionsEN" trait="AlmadarPostLearningFromInterruptionsENPostPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="AlmadarPostLearningFromInterruptionsENPostPage">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><AlmadarPostLearningFromInterruptionsENPostHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Box paddingY="xl" bg="transparent" fullWidth={true}><Container maxWidth="xl" size="xl" padding="lg"><AlmadarPostLearningFromInterruptionsENPostView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Container></Box><AlmadarPostLearningFromInterruptionsENPostFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default AlmadarPostLearningFromInterruptionsENPostPageView;
